import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
import { Activity, Minimize2, RefreshCw, Network } from 'lucide-react';
export function WhatIsCLVN() {
  const {
    t
  } = useI18n();
  const chips = [{
    icon: <Activity size={14} data-id="element-221" />,
    label: t('whatIs.chips.latencia')
  }, {
    icon: <Minimize2 size={14} data-id="element-222" />,
    label: t('whatIs.chips.reversibilidad')
  }, {
    icon: <RefreshCw size={14} data-id="element-223" />,
    label: t('whatIs.chips.resonancia')
  }, {
    icon: <Network size={14} data-id="element-224" />,
    label: t('whatIs.chips.sistemas')
  }];
  return <section className="py-32 relative border-t border-white/5" data-id="element-225">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-226">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-227">
          {/* Left Column - Prose */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-228">
            <h2 className="font-display text-4xl md:text-5xl mb-8 text-white" data-id="element-229">
              {t('whatIs.title')}
            </h2>
            <div className="space-y-6 text-lg text-gray-400 font-light leading-relaxed" data-id="element-230">
              <p data-id="element-231">{t('whatIs.p1')}</p>
              <p data-id="element-232">{t('whatIs.p2')}</p>
            </div>

            <div className="mt-12 flex flex-wrap gap-3" data-id="element-233">
              {chips.map((chip, i) => <div key={i} className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 bg-white/5 text-sm text-gray-300" data-id="element-234">
                  <span className="text-violet-electric" data-id="element-235">{chip.icon}</span>
                  {chip.label}
                </div>)}
            </div>
          </motion.div>

          {/* Right Column - Equation */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-236">
            <div className="absolute inset-0 bg-violet-deep/20 blur-[100px] rounded-full pointer-events-none" data-id="element-237" />
            <div className="relative glass-panel p-12 md:p-16 rounded-2xl flex flex-col items-center justify-center text-center" data-id="element-238">
              <div className="font-mono text-4xl md:text-6xl text-white mb-8 tracking-tight" data-id="element-239">
                λ(a) = a · 10
                <sup className="text-2xl md:text-4xl text-violet-electric" data-id="element-240">
                  −100
                </sup>
              </div>
              <div className="h-px w-16 bg-white/20 mb-8" data-id="element-241" />
              <p className="text-sm text-gray-400 font-mono uppercase tracking-widest max-w-xs leading-relaxed" data-id="element-242">
                {t('whatIs.equationCaption')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}